export default __webpack_public_path__ + "static/media/cattleytics-logo-light-with-tagline.e31a48d1.png";